import ApiClient from './ApiClient';

class Funnel extends ApiClient {
  constructor() {
    super('funnel', { accountScoped: true });
  }
}

export default new Funnel();
